import { Injectable } from '@angular/core';
import {GridItem} from '../models/gridItem';
import {ChartType} from '../models/chartType';

@Injectable()
export class GridItemFactoryService {

  private dropDownControllerDefaultGridItem: Partial<GridItem> = {
    cols: 9,
    rows: 1,
    minItemRows: 1,
    minItemCols: 3,
  };

  private advancedFilterControllerDefaultGridItem: Partial<GridItem> = {
    cols: 9,
    rows: 1,
    minItemRows: 1,
    minItemCols: 3,
  };

  private sliderControllerDefaultGridItem: Partial<GridItem> = {
    cols: 9,
    rows: 1,
    minItemRows: 1,
    minItemCols: 3,
  };

  private dateListControllerDefaultGridItem: Partial<GridItem> = {
    cols: 9,
    rows: 1,
    minItemRows: 1,
    minItemCols: 3,
  };


  private dateRangeControllerDefaultGridItem: Partial<GridItem> = {
    cols: 9,
    rows: 1,
    minItemRows: 1,
    minItemCols: 3,
  };

  private barChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private stackedBarChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private stacked100BarChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private cardChartDefaultGridItem: Partial<GridItem> = {
    cols: 6,
    rows: 2,
    minItemRows: 1,
    minItemCols: 3,
  };

  private advancedCardChartDefaultGridItem: Partial<GridItem> = {
    cols: 6,
    rows: 2,
    minItemRows: 1,
    minItemCols: 3,
  };

  private buttonChartDefaultGridItem: Partial<GridItem> = {
    cols: 4,
    rows: 1,
    minItemRows: 1,
    minItemCols: 3,
  };

  private tableChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private barChartHorizontalDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private stackedBarChartHorizontalDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private stacked100BarChartHorizontalDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private pieChartDefaultGridItem: Partial<GridItem> = {
    cols: 12,
    rows: 4,
    minItemRows: 1,
    minItemCols: 3,
  };

  private doughnutChartDefaultGridItem: Partial<GridItem> = {
    cols: 12,
    rows: 4,
    minItemRows: 1,
    minItemCols: 3,
  };

  private lineChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private areaChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private lineStackChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private stackedColumnLineChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private clusteredColumnLineChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private textChartDefaultGridItem: Partial<GridItem> = {
    cols: 9,
    rows: 3,
    minItemRows: 1,
    minItemCols: 3,
  };

  private iframeChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private imageChartDefaultGridItem: Partial<GridItem> = {
    cols: 9,
    rows: 3,
    minItemRows: 1,
    minItemCols: 3,
  };

  private scatterChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private shapeMapChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private gaugeChartDefaultGridItem: Partial<GridItem> = {
    cols: 12,
    rows: 4,
    minItemRows: 1,
    minItemCols: 3,
  };

  private advancedGaugeChartDefaultGridItem: Partial<GridItem> = {
    cols: 12,
    rows: 4,
    minItemRows: 1,
    minItemCols: 3,
  };

  private radarChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private treeMapChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private sankeyChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private kpiChartDefaultGridItem: Partial<GridItem> = {
    cols: 9,
    rows: 3,
    minItemRows: 1,
    minItemCols: 3,
  };

  private collapsableChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private waterfallChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private geoMapChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private bubbleMapChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };

  private matrixChartDefaultGridItem: Partial<GridItem> = {
    cols: 18,
    rows: 5,
    minItemRows: 1,
    minItemCols: 3,
  };


  private defaultGridItems = {
    barChart: this.barChartDefaultGridItem,
    stackedBarChart: this.stackedBarChartDefaultGridItem,
    stacked100BarChart: this.stacked100BarChartDefaultGridItem,
    dropdownController: this.dropDownControllerDefaultGridItem,
    advancedFilterController: this.advancedFilterControllerDefaultGridItem,
    sliderController: this.sliderControllerDefaultGridItem,
    dateListController: this.dateListControllerDefaultGridItem,
    cardChart: this.cardChartDefaultGridItem,
    advancedCardChart: this.advancedCardChartDefaultGridItem,
    buttonChart: this.buttonChartDefaultGridItem,
    tableChart: this.tableChartDefaultGridItem,
    barChartHorizontal: this.barChartHorizontalDefaultGridItem,
    stackedBarChartHorizontal: this.stackedBarChartHorizontalDefaultGridItem,
    stacked100BarChartHorizontal: this.stacked100BarChartHorizontalDefaultGridItem,
    pieChart: this.pieChartDefaultGridItem,
    doughnutChart: this.doughnutChartDefaultGridItem,
    lineChart: this.lineChartDefaultGridItem,
    areaChart: this.areaChartDefaultGridItem,
    lineStackChart: this.lineStackChartDefaultGridItem,
    stackedColumnLineChart: this.stackedColumnLineChartDefaultGridItem,
    clusteredColumnLineChart: this.clusteredColumnLineChartDefaultGridItem,
    dateRangeController: this.dateRangeControllerDefaultGridItem,
    textChart: this.textChartDefaultGridItem,
    iframeChart: this.iframeChartDefaultGridItem,
    imageChart: this.imageChartDefaultGridItem,
    scatterChart: this.scatterChartDefaultGridItem,
    shapeMap: this.shapeMapChartDefaultGridItem,
    gaugeChart: this.gaugeChartDefaultGridItem,
    advancedGaugeChart: this.advancedGaugeChartDefaultGridItem,
    radarChart: this.radarChartDefaultGridItem,
    treeMap: this.treeMapChartDefaultGridItem,
    sankeyChart: this.sankeyChartDefaultGridItem,
    kPIChart: this.kpiChartDefaultGridItem,
    collapsableNetworkChart: this.collapsableChartDefaultGridItem,
    waterFall: this.waterfallChartDefaultGridItem,
    matrix: this.matrixChartDefaultGridItem,
    geoMapChart: this.geoMapChartDefaultGridItem,
    bubbleChart: this.bubbleMapChartDefaultGridItem,
  };

  private static layoutVersion02GridSizes = {
    ImageChart: {
      cols: 20,
      rows: 22
    },
    GaugeChart: {
      cols: 20,
      rows: 22
    },
    TextChart: {
      cols: 20,
      rows: 22
    },
    AdvancedGaugeChart: {
      cols: 20,
      rows: 22
    },
    KPIChart: {
      cols: 20,
      rows: 22
    },
    DoughnutChart: {
      cols: 20,
      rows: 22
    },
    PieChart: {
      cols: 20,
      rows: 22
    },
    CardChart: {
      cols: 20,
      rows: 22
    },
    AdvancedCardChart: {
      cols: 20,
      rows: 22
    },
    IframeChart: {
      cols: 20,
      rows: 22
    },
    DateRangeController: {
      cols: 20,
      rows: 7
    },
    DateListController: {
      cols: 20,
      rows: 7
    },
    SliderController: {
      cols: 20,
      rows: 7
    },
    AdvancedFilterController: {
      cols: 20,
      rows: 7
    },
    DropdownController: {
      cols: 20,
      rows: 7
    },
    ButtonChart: {
      cols: 9,
      rows: 7
    },
  };

  constructor() {
  }

  public getDefaultGridItem(chartType: ChartType): Partial<GridItem>{
    let chartTypeString = chartType.toString();
    chartTypeString = chartTypeString.charAt(0).toLowerCase() + chartTypeString.slice(1);
    return this.defaultGridItems[chartTypeString];
  }

  public static getLayoutVersion02GridSizes(chartType: ChartType){
    return GridItemFactoryService.layoutVersion02GridSizes[chartType];
  }
}
